import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Link as LinkIcon, Menu, X, ChevronDown } from "lucide-react";
import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const industryLinks = [
  { label: "B2B", to: "/b2b-link-building" },
  { label: "Gambling", to: "/gambling-link-building" },
  { label: "FinTech", to: "/industries/fintech" },
  { label: "Insurance", to: "/industries/insurance" },
  { label: "SaaS", to: "/industries/saas" },
  { label: "Education", to: "/industries/education" },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary border-b border-primary-foreground/10">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-2 text-primary-foreground">
            <div className="flex items-center justify-center w-10 h-10 bg-accent rounded-lg">
              <LinkIcon className="w-6 h-6" />
            </div>
            <span className="text-2xl font-bold">linkzy</span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-primary-foreground hover:text-primary-foreground/80 transition-colors font-medium">
              Home
            </Link>
            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center gap-1 text-primary-foreground hover:text-primary-foreground/80 transition-colors font-medium outline-none">
                Link Building
                <ChevronDown className="w-4 h-4" aria-hidden="true" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-56 bg-popover">
                <DropdownMenuItem asChild>
                  <Link to="/guest-post-service" className="cursor-pointer font-medium">
                    Guest Post Service
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <div className="px-2 py-1.5 text-xs text-muted-foreground">
                  Industries
                </div>
                {industryLinks.map((item) => (
                  <DropdownMenuItem key={item.to} asChild>
                    <Link to={item.to} className="cursor-pointer">
                      {item.label}
                    </Link>
                  </DropdownMenuItem>
                ))}
                <DropdownMenuSeparator />
                <DropdownMenuItem asChild>
                  <Link to="/industries" className="cursor-pointer font-semibold text-accent">
                    All Industries
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>

            </DropdownMenu>
            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center gap-1 text-primary-foreground hover:text-primary-foreground/80 transition-colors font-medium outline-none">
                AEO / GEO
                <ChevronDown className="w-4 h-4" aria-hidden="true" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-60 bg-popover">
                <DropdownMenuItem asChild>
                  <Link to="/aeo-geo-services" className="cursor-pointer font-medium">
                    AEO / GEO Services
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/ai-visibility-audit" className="cursor-pointer font-medium">
                    Free AI Visibility Audit
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/ai-visibility-checker" className="cursor-pointer font-medium">
                    Free AI Visibility Checker
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            <Link to="/pricing" className="text-primary-foreground hover:text-primary-foreground/80 transition-colors font-medium">
              Pricing
            </Link>
            <Link to="/blog" className="text-primary-foreground hover:text-primary-foreground/80 transition-colors font-medium">
              Blog
            </Link>
          </nav>

          <div className="flex items-center gap-4">
            <Link to="/contact" className="hidden md:block">
              <Button variant="secondary">
                Contact Us
              </Button>
            </Link>
            
            <Button 
              variant="ghost" 
              size="icon" 
              className="md:hidden text-primary-foreground"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={mobileMenuOpen}
            >
              {mobileMenuOpen ? <X className="w-6 h-6" aria-hidden="true" /> : <Menu className="w-6 h-6" aria-hidden="true" />}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden max-h-[calc(100dvh-5rem)] overflow-y-auto border-t border-primary-foreground/10 py-4 animate-fade-in">
            <nav className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-primary-foreground hover:bg-primary-foreground/10 transition-all font-medium py-3 px-4 rounded-lg active:scale-95"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              <div className="text-primary-foreground font-medium py-3 px-4">
                Link Building
              </div>
              <Link 
                to="/guest-post-service"
                className="text-primary-foreground/80 hover:bg-primary-foreground/10 transition-all text-sm py-2 px-8 rounded-lg active:scale-95 font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Guest Post Service
              </Link>


              <div className="text-primary-foreground/60 text-xs font-medium py-2 px-8 uppercase tracking-wide">
                Industries
              </div>
              {industryLinks.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="text-primary-foreground/80 hover:bg-primary-foreground/10 transition-all text-sm py-2 px-8 rounded-lg active:scale-95"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              <Link 
                to="/industries"
                className="text-primary-foreground/80 hover:bg-primary-foreground/10 transition-all text-sm py-2 px-8 rounded-lg active:scale-95 font-semibold text-accent"
                onClick={() => setMobileMenuOpen(false)}
              >
                All Industries
              </Link>

              <div className="text-primary-foreground font-medium py-3 px-4">
                AEO / GEO
              </div>
              <Link 
                to="/aeo-geo-services"
                className="text-primary-foreground/80 hover:bg-primary-foreground/10 transition-all text-sm py-2 px-8 rounded-lg active:scale-95 font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                AEO / GEO Services
              </Link>
              <Link 
                to="/ai-visibility-audit"
                className="text-primary-foreground/80 hover:bg-primary-foreground/10 transition-all text-sm py-2 px-8 rounded-lg active:scale-95 font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Free AI Visibility Audit
              </Link>
              <Link 
                to="/ai-visibility-checker"
                className="text-primary-foreground/80 hover:bg-primary-foreground/10 transition-all text-sm py-2 px-8 rounded-lg active:scale-95 font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Free AI Visibility Checker
              </Link>

              <Link 
                to="/pricing" 
                className="text-primary-foreground hover:bg-primary-foreground/10 transition-all font-medium py-3 px-4 rounded-lg active:scale-95"
                onClick={() => setMobileMenuOpen(false)}
              >
                Pricing
              </Link>
              <Link 
                to="/blog" 
                className="text-primary-foreground hover:bg-primary-foreground/10 transition-all font-medium py-3 px-4 rounded-lg active:scale-95"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </Link>
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="mt-2">
                <Button variant="secondary" className="w-full h-12 text-base active:scale-95 transition-transform">
                  Contact Us
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
